import { useParsed } from '@refinedev/core'
import { useTranslation } from 'react-i18next'
import { EditView, EditViewHeader } from '~/components/refineUi/views/editView'
import { CabinetForm } from './form'

export function CabinetEdit() {
  const { t } = useTranslation()
  const { id } = useParsed()
  return (
    <EditView>
      <EditViewHeader title={t('cabinetsPage.edit.title')} />
      <CabinetForm
        action="edit"
        id={String(id)}
      />
    </EditView>
  )
}
